import {
  useEffect,
} from 'react';
import { useDispatch } from 'react-redux';
import Modal, { type Styles } from 'react-modal';

import {
  Icon,
} from 'web-components';
import {
  uiActions,
} from 'web-actions';
import {
  Flex,
} from 'web-styled';

import * as S from './styled';

const link = 'https://www.youtube.com/embed/VOhrl6xH1TQ?autoplay=1&amp;enablejsapi=1&amp;version=3&amp;playerapiid=ytplayer';

const getCustomStyles: Styles = {
  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    overflow: 'hidden auto',
    paddingBottom: '50px',
    width: '100%',
    zIndex: 9999,
  },
  content: {
    padding: 0,
    borderRadius: 0,
    background: 'none',
    position: 'relative',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    marginTop: '50px',
    marginBottom: 'auto',
    width: '100%',
    border: 'none',
    outline: 'none',
    overflow: 'visible',
  },
}

interface Props {
  isOpen: boolean,
  videoSrc?: string,
  onRequestClose: { (): void };
}

const TutorialVideoModal = ({ isOpen, videoSrc, onRequestClose }: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onRequestClose();
    }
    if (isOpen) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, dispatch]);

  if (!isOpen || !videoSrc) return null

  return (
    <Modal
      style={getCustomStyles}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      isOpen={isOpen}
      bodyOpenClassName="onboarding-video-open"
    >
      <S.ModalContent>
        <Flex
          clickable
          alignSelf="flex-end"
          onClick={onRequestClose}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.9612 11.9739L23.3228 3.61234C23.7196 3.21621 23.9428 2.67865 23.9433 2.11793C23.9438 1.55721 23.7215 1.01926 23.3254 0.622421C22.9293 0.225582 22.3917 0.00236267 21.831 0.00186748C21.2703 0.00137229 20.7323 0.223642 20.3355 0.61978L11.9739 8.98135L3.61234 0.61978C3.2155 0.222942 2.67728 0 2.11606 0C1.55485 0 1.01662 0.222942 0.61978 0.61978C0.222942 1.01662 0 1.55485 0 2.11606C0 2.67728 0.222942 3.2155 0.61978 3.61234L8.98135 11.9739L0.61978 20.3355C0.222942 20.7323 0 21.2706 0 21.8318C0 22.393 0.222942 22.9312 0.61978 23.3281C1.01662 23.7249 1.55485 23.9478 2.11606 23.9478C2.67728 23.9478 3.2155 23.7249 3.61234 23.3281L11.9739 14.9665L20.3355 23.3281C20.7323 23.7249 21.2706 23.9478 21.8318 23.9478C22.393 23.9478 22.9312 23.7249 23.3281 23.3281C23.7249 22.9312 23.9478 22.393 23.9478 21.8318C23.9478 21.2706 23.7249 20.7323 23.3281 20.3355L14.9612 11.9739Z"
              fill="#CECECE"
            />
          </svg>
        </Flex>
        <S.Video>
          <S.Frame
            src={videoSrc}
            allow="autoplay"
            allowFullScreen
          />
        </S.Video>
      </S.ModalContent>
    </Modal>
  )
}

export default TutorialVideoModal
